import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { site, telephoneHref } from "@/lib/site";

const Footer = () => {
  return (
    <footer className="bg-foreground text-background">
      <div className="container py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <h3 className="font-heading font-bold text-lg mb-3">{site.shortName}</h3>
            <p className="text-background/70 text-sm leading-relaxed">
              Property cleanouts, debris removal, rental turnovers, and selective interior demolition across Northeast Wisconsin.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold mb-3">Quick Links</h4>
            <nav className="flex flex-col gap-2 text-sm text-background/70">
              <Link to="/" className="hover:text-background transition-colors">Home</Link>
              <Link to="/services" className="hover:text-background transition-colors">Services</Link>
              <Link to="/services/estate-cleanout-wisconsin" className="hover:text-background transition-colors">Estate Cleanouts</Link>
              <Link to="/services/foreclosure-cleanout-wi" className="hover:text-background transition-colors">Foreclosure Cleanouts</Link>
              <Link to="/services/apartment-turnover-wi" className="hover:text-background transition-colors">Apartment Turnovers</Link>
              <Link to="/services/interior-demolition-wisconsin" className="hover:text-background transition-colors">Interior Demolition</Link>
              <Link to="/about" className="hover:text-background transition-colors">About Us</Link>
              <Link to="/gallery" className="hover:text-background transition-colors">Gallery</Link>
              <Link to="/blog" className="hover:text-background transition-colors">Blog</Link>
              <Link to="/contact" className="hover:text-background transition-colors">Contact</Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading font-semibold mb-3">Contact Us</h4>
            <div className="flex flex-col gap-3 text-sm text-background/70">
              <a href={telephoneHref} className="flex items-center gap-2 hover:text-background transition-colors">
                <Phone className="w-4 h-4 shrink-0" />
                {site.phone}
              </a>
              <a href={`mailto:${site.email}`} className="flex items-center gap-2 hover:text-background transition-colors">
                <Mail className="w-4 h-4 shrink-0" />
                {site.email}
              </a>
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 shrink-0 mt-0.5" />
                {site.city}, {site.region} {site.postalCode}
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background/20 mt-10 pt-6 text-center text-xs text-background/50">
          © {new Date().getFullYear()} {site.shortName}. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
